import fetchRules from './fetchRules';
import fetchRule from './fetchRule';
import createRule from './createRule';
import updateRule from './updateRule';
import deleteRule from './deleteRule';

export default {
    fetchRules,
    fetchRule,
    createRule,
    updateRule,
    deleteRule,
};